// review-comments.js — D10 comment/notification API shapes -> workspace camelCase.

function hasOwn(value, key) {
  return !!value && Object.prototype.hasOwnProperty.call(value, key);
}

export function commentAuthor(author, fallbackRole = null) {
  if (author && typeof author === 'object') {
    return {
      author: author.user_id || author.userId || 'A teammate',
      role: author.role || fallbackRole || 'Reviewer',
    };
  }
  return {
    author: typeof author === 'string' && author ? author : 'A teammate',
    role: fallbackRole || 'Reviewer',
  };
}

export function mapCommentReply(reply) {
  const source = reply || {};
  const who = commentAuthor(source.author, source.role);
  return {
    id: source.id,
    author: who.author,
    role: who.role,
    body: source.body || '',
    mentions: Array.isArray(source.mentions) ? source.mentions : [],
    createdAt: source.created_at || source.createdAt || null,
    chaseOperations: Array.isArray(source.chase_operations) ? source.chase_operations : [],
    ...(source.patch ? { patch: true } : {}),
  };
}

export function mapCommentThread(thread) {
  const source = thread || {};
  const who = commentAuthor(source.author, source.role);
  return {
    id: source.id,
    jobId: source.job_id || source.jobId || null,
    revisionDigest: source.revision_digest || source.revisionDigest || null,
    regionId: hasOwn(source, 'region_id') ? source.region_id : (source.regionId ?? null),
    author: who.author,
    role: who.role,
    body: source.body || '',
    mentions: Array.isArray(source.mentions) ? source.mentions : [],
    open: source.open !== false,
    createdAt: source.created_at || source.createdAt || null,
    chaseOperations: Array.isArray(source.chase_operations) ? source.chase_operations : [],
    replies: (Array.isArray(source.replies) ? source.replies : []).map(mapCommentReply),
    stale: hasOwn(source, 'stale') ? source.stale : null,
    orphaned: hasOwn(source, 'orphaned') ? source.orphaned : null,
    stateBy: source.state_by || source.stateBy || null,
    stateAt: source.state_at || source.stateAt || null,
  };
}

export function mapCommentEnvelope(result) {
  const rows = Array.isArray(result) ? result : result && result.threads;
  return (Array.isArray(rows) ? rows : []).map(mapCommentThread);
}

export function mapNotification(notification) {
  const source = notification || {};
  return {
    id: source.id,
    actorId: source.actor_id || source.actorId || null,
    kind: source.kind,
    jobId: source.job_id || source.jobId || null,
    threadId: source.thread_id || source.threadId || null,
    commentId: source.comment_id || source.commentId || null,
    bodyExcerpt: source.body_excerpt || source.bodyExcerpt || '',
    readAt: source.read_at || source.readAt || null,
    createdAt: source.created_at || source.createdAt || null,
  };
}

export function mapNotificationEnvelope(result) {
  const rows = Array.isArray(result) ? result : result && result.notifications;
  return (Array.isArray(rows) ? rows : []).map(mapNotification);
}

const GooseReviewComments = {
  commentAuthor,
  mapCommentReply,
  mapCommentThread,
  mapCommentEnvelope,
  mapNotification,
  mapNotificationEnvelope,
};

if (typeof window !== 'undefined') window.GooseReviewComments = GooseReviewComments;

export default GooseReviewComments;
